import { useEffect } from "react";
import { X } from "lucide-react";

export default function BetaWelcomeModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;

    document.body.style.overflow = "hidden";

    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center bg-[#0F172A]/35 backdrop-blur-md px-4 animate-in fade-in duration-300"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md rounded-3xl bg-white shadow-[0_30px_80px_rgba(15,31,61,0.25)] border border-[#E2E8F0] p-10 animate-in zoom-in-95 duration-300"
      >
        <button
          onClick={onClose}
          className="absolute right-5 top-5 text-slate-400 hover:text-slate-700 transition"
        >
          <X size={20} />
        </button>

        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center gap-1 rounded-full border border-[#D8E3F0] bg-[#F8FAFC] px-4 py-2 text-xs font-semibold tracking-wide text-[#64748B]">
            <span className="h-2 w-[9px] rounded-full bg-[#10B981]" />
            BETA v1.0
          </span>
        </div>

        <h2 className="text-3xl font-bold text-center text-[#0F1F3D]">
          Welcome to LaunchRadar
        </h2>

        <p className="mt-5 text-center text-[#64748B] leading-7">
          You're trying an early beta version.
        </p>

        <p className="mt-5 text-center text-[#64748B] leading-7">
          Some areas are still being refined, and things may change as we
          continue improving the experience.
        </p>

        <p className="mt-5 text-center text-[#64748B] leading-7">
          We'd love your feedback while you explore - it helps us build something
          better.
        </p>

        <button
          onClick={onClose}
          className="mt-8 w-full rounded-xl bg-[#0F1F3D] py-4 text-white font-semibold hover:bg-[#16294C] transition"
        >
          Continue to site
        </button>
      </div>
    </div>
  );
}